"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const Storage_1 = require("./Storage");
const customLoader_1 = require("../elements/customLoader");
var Loader;
(function (Loader) {
    class LoaderController {
        static appendRequest() {
            const location = window.location.href;
            let storageData = Storage_1.Storage.StorageController.getFromStorage('LoaderController');
            if (storageData && storageData.location === location) {
                storageData.running = storageData.running + 1;
            }
            else {
                storageData = { running: 1, location: location };
            }
            Storage_1.Storage.StorageController.saveToStorage('LoaderController', storageData);
            customLoader_1.CustomLoader.UiHandler.showLoader();
        }
        static removeRequest() {
            const location = window.location.href;
            let storageData = Storage_1.Storage.StorageController.getFromStorage('LoaderController');
            if (storageData && storageData.location === location) {
                storageData.running = storageData.running - 1;
            }
            else {
                storageData = { running: 0, location: location };
            }
            if (storageData.running < 0) {
                storageData.running = 0;
            }
            Storage_1.Storage.StorageController.saveToStorage('LoaderController', storageData);
            if (storageData.running === 0) {
                customLoader_1.CustomLoader.UiHandler.hideLoader();
            }
        }
    }
    Loader.LoaderController = LoaderController;
})(Loader || (exports.Loader = Loader = {}));
